import { useTranslate } from "@tolgee/react";
import React from "react";
import { Modal, Button } from "react-bootstrap";

export const PostLoaderModal: React.FC<any> = ({
  isOpen,
  onClose,
  onPostLoad,
  onPostDiscard,
}) => {
  const { t } = useTranslate();

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header className="border-0">
        <span className="fw-bold">
          {t("lomavisCreator.postLoaderModal.loadPostTitle")}
        </span>
      </Modal.Header>
      <Modal.Footer className="border-0">
        <Button variant="secondary" onClick={onPostDiscard} size="sm">
          {t("lomavisCreator.postLoaderModal.discard")}
        </Button>
        <Button variant="primary" onClick={onPostLoad} size="sm">
          {t("lomavisCreator.postLoaderModal.loadPost")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
